module.exports = __webpack_public_path__ + "img/banner.79c12dc0.png";